import React from 'react';
import { Phone, Mail, MapPin, Instagram, Twitter, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute inset-0 bg-[#FAF9F5]" />

      <div className="relative z-10">
        {/* Main Footer Content */}
        <div className="pp-container py-16">
          {/* Top Section - Logo & Licenses */}
          <div className="grid md:grid-cols-2 gap-12 mb-12 pb-12 border-b border-black/35">
            {/* Logo & Description */}
            <div className="space-y-6">
              <div className="flex items-center gap-3">
 <img
  src="/images/parspiping-logo.svg"
  alt="پارس پایپینگ"
  className="h-12 md:h-14 lg:h-16 w-auto object-contain"
 />
  
</div>
              <p className="text-slate-600 text-lg leading-relaxed">
                تامین کننده تجهیزات صنعتی با بیش از ۱۵ سال تجربه. کیفیت، اعتماد و تخصص در خدمت شما
              </p>

              {/* Social Media */}
              <div className="flex gap-3">
                <a
                  href="#"
                  className="group w-12 h-12 bg-white border border-slate-200 rounded-xl flex items-center justify-center hover:bg-[#005bbb] hover:border-[#005bbb] transition-all"
                >
                  <Instagram className="w-5 h-5 text-slate-500 group-hover:text-white transition-colors" />
                </a>
                <a
                  href="#"
                  className="group w-12 h-12 bg-white border border-slate-200 rounded-xl flex items-center justify-center hover:bg-[#005bbb] hover:border-[#005bbb] transition-all"
                >
                  <Twitter className="w-5 h-5 text-slate-500 group-hover:text-white transition-colors" />
                </a>
                <a
                  href="#"
                  className="group w-12 h-12 bg-white border border-slate-200 rounded-xl flex items-center justify-center hover:bg-[#005bbb] hover:border-[#005bbb] transition-all"
                >
                  <Linkedin className="w-5 h-5 text-slate-500 group-hover:text-white transition-colors" />
                </a>
              </div>
            </div>

            {/* Licenses / Badges */}
            <div className="flex flex-col items-center md:items-start justify-between gap-6">
              <div className="text-center justify-start md:text-right">
                <h3 className="text-xl font-bold text-slate-900 mb-2">
                  مجوزها و نمادها
                </h3>
                <p className="text-slate-600 text-sm">
                  نمادهای اعتماد و مجوزهای رسمی فعالیت مجموعه
                </p>
              </div>

              <div className="flex flex-wrap justify-center md:justify-end gap-4">
                {/* Badge 1 */}
                <a
                  href="#"
                  className="w-24 h-24 sm:w-28 sm:h-28 bg-white border border-slate-200 rounded-2xl flex items-center justify-center hover:border-[#005bbb] hover:bg-blue-50 transition-all"
                >
                  {/* اینجا تصویر ای‌نماد واقعی را قرار بده */}
                  <span className="text-xs text-slate-500 text-center leading-5">
                    جای لوگوی
                    <br />
                    ای‌نماد
                  </span>
                </a>

                {/* Badge 2 */}
                <a
                  href="#"
                  className="w-24 h-24 sm:w-28 sm:h-28 bg-white border border-slate-200 rounded-2xl flex items-center justify-center hover:border-[#005bbb] hover:bg-blue-50 transition-all"
                >
                  <span className="text-xs text-slate-500 text-center leading-5">
                    جای لوگوی
                    <br />
                    ساماندهی
                  </span>
                </a>

                {/* Badge 3 */}
                <a
                  href="#"
                  className="w-24 h-24 sm:w-28 sm:h-28 bg-white border border-slate-200 rounded-2xl flex items-center justify-center hover:border-[#005bbb] hover:bg-blue-50 transition-all"
                >
                  <span className="text-xs text-slate-500 text-center leading-5">
                    سایر
                    <br />
                    مجوزها
                  </span>
                </a>
                {/* Badge 4 */}
                <a
                  href="#"
                  className="w-24 h-24 sm:w-28 sm:h-28 bg-white border border-slate-200 rounded-2xl flex items-center justify-center hover:border-[#005bbb] hover:bg-blue-50 transition-all"
                >
                  <span className="text-xs text-slate-500 text-center leading-5">
                    سایر
                    <br />
                    مجوزها
                  </span>
                </a>
                
              </div>
            </div>
          </div>

          {/* Links Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
            {/* Column 1 - Contact */}
            <div className="space-y-4">
              <h4 className="w-28 text-lg font-bold text-slate-900 mb-4 pb-2 border-b-2 border-[#005bbb]">
                تماس با ما
              </h4>
              <ul className="space-y-4">
                <li className="flex items-center gap-3 text-slate-600 text-sm group">
                  <div className="w-10 h-10 bg-[#005bbb]/10 rounded-lg flex items-center justify-center group-hover:bg-[#005bbb] transition-colors">
                    <Phone className="w-5 h-5 text-[#005bbb] group-hover:text-white transition-colors" />
                  </div>
                  <span>021-12345678</span>
                </li>
                <li className="flex items-center gap-3 text-slate-600 text-sm group">
                  <div className="w-10 h-10 bg-[#005bbb]/10 rounded-lg flex items-center justify-center group-hover:bg-[#005bbb] transition-colors">
                    <Mail className="w-5 h-5 text-[#005bbb] group-hover:text-white transition-colors" />
                  </div>
                  <span>info@example.com</span>
                </li>
                <li className="flex items-start gap-3 text-slate-600 text-sm group">
                  <div className="w-10 h-10 bg-[#005bbb]/10 rounded-lg flex items-center justify-center group-hover:bg-[#005bbb] transition-colors flex-shrink-0">
                    <MapPin className="w-5 h-5 text-[#005bbb] group-hover:text-white transition-colors" />
                  </div>
                  <span>تهران، میدان ولیعصر</span>
                </li>
              </ul>
            </div>

            {/* Column 2 - Quick Links */}
            <div className="space-y-4">
              <h4 className="w-28 text-lg font-bold text-slate-900 mb-4 pb-2 border-b-2 border-[#005bbb]">
                دسترسی سریع
              </h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="#"
                    className="text-slate-600 hover:text-[#005bbb] transition-colors text-sm flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 bg-slate-400 rounded-full group-hover:bg-[#005bbb] transition-colors"></span>
                    درباره ما
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-slate-600 hover:text-[#005bbb] transition-colors text-sm flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 bg-slate-400 rounded-full group-hover:bg-[#005bbb] transition-colors"></span>
                    محصولات
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-slate-600 hover:text-[#005bbb] transition-colors text-sm flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 bg-slate-400 rounded-full group-hover:bg-[#005bbb] transition-colors"></span>
                    برندها
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-slate-600 hover:text-[#005bbb] transition-colors text-sm flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 bg-slate-400 rounded-full group-hover:bg-[#005bbb] transition-colors"></span>
                    تماس با ما
                  </a>
                </li>
              </ul>
            </div>

            {/* Column 3 - Services */}
            <div className="space-y-4">
              <h4 className="w-28 text-lg font-bold text-slate-900 mb-4 pb-2 border-b-2 border-[#005bbb]">
                خدمات
              </h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="#"
                    className="text-slate-600 hover:text-[#005bbb] transition-colors text-sm flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 bg-slate-400 rounded-full group-hover:bg-[#005bbb] transition-colors"></span>
                    ثبت لیست خرید
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-slate-600 hover:text-[#005bbb] transition-colors text-sm flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 bg-slate-400 rounded-full group-hover:bg-[#005bbb] transition-colors"></span>
                    صدور پیش فاکتور
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-slate-600 hover:text-[#005bbb] transition-colors text-sm flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 bg-slate-400 rounded-full group-hover:bg-[#005bbb] transition-colors"></span>
                    مشاوره تخصصی
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-slate-600 hover:text-[#005bbb] transition-colors text-sm flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 bg-slate-400 rounded-full group-hover:bg-[#005bbb] transition-colors"></span>
                    ارسال سراسری
                  </a>
                </li>
              </ul>
            </div>

            {/* Column 4 - Categories */}
            <div className="space-y-4">
              <h4 className="w-28 text-lg font-bold text-slate-900 mb-4 pb-2 border-b-2 border-[#005bbb]">
                دسته‌بندی‌ها
              </h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="#"
                    className="text-slate-600 hover:text-[#005bbb] transition-colors text-sm flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 bg-slate-400 rounded-full group-hover:bg-[#005bbb] transition-colors"></span>
                    پارس پایپینگ
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-slate-600 hover:text-[#005bbb] transition-colors text-sm flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 bg-slate-400 rounded-full group-hover:bg-[#005bbb] transition-colors"></span>
                    لوله فلزی
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-slate-600 hover:text-[#005bbb] transition-colors text-sm flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 bg-slate-400 rounded-full group-hover:bg-[#005bbb] transition-colors"></span>
                    اتصالات فلزی
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-slate-600 hover:text-[#005bbb] transition-colors text-sm flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 bg-slate-400 rounded-full group-hover:bg-[#005bbb] transition-colors"></span>
                    لوله پلیمری
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>

        {/* Bottom Copyright Bar */}
        <div className="border-t border-black/35 bg-[#FAF9F5]">
          <div className="pp-container py-6">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <p className="text-slate-600 text-sm">
                © 2025 پارس پایپینگ. تمامی حقوق محفوظ است.
              </p>
              <div className="flex items-center gap-6 text-sm">
                <a href="#" className="text-slate-600 hover:text-[#005bbb] transition-colors">
                  قوانین و مقررات
                </a>
                <a href="#" className="text-slate-600 hover:text-[#005bbb] transition-colors">
                  حریم خصوصی
                </a>
                <a href="#" className="text-slate-600 hover:text-[#005bbb] transition-colors">
                  سوالات متداول
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
